export default __webpack_public_path__ + "static/media/help.cee2c8fd.svg";